<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <div class="top-center">
      <h3>订单支付</h3>
      <div class="content">
        <div class="title">
          订单已提交，请在
          <span class="time">{{rentTime}}</span>秒内完成网上支付
        </div>
        <div class="day">订单编号：{{detail.order_sn}}</div>
        <div class="day">参观日期：{{detail.t_date}} {{detail.time_period}}</div>

        <div class="money">
          总价：
          <span>
            ￥
            <span class="num">{{Number(detail.order_amount).toFixed(2)}}</span>
          </span>
        </div>
      </div>
      <h3>支付方式</h3>
      <div class="payment-type">
        <div class="item" :class="{'active':curs==1}" @click="curs=1"></div>
        <div class="item" :class="{'active':curs==4}" @click="curs=4"></div>
        <!-- <div class="item" :class="{'active':curs==5}" @click="curs=5"></div> -->
      </div>
      <div class="btn-group">
        <div class="back-btn" @click="cancelOrder">取消支付</div>
        <div class="ok" @click="goPay">确认支付</div>
        <!-- <div class="oks" @click="print_ticket" v-if="detail.order_amount==0">打印取票</div> -->
      </div>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="mask" v-if="printF">
      <div class="mask-content">
        <div class="icon2"></div>
        <p>出票中，请稍后……</p>
      </div>
    </div>
    <div class="mold" v-if="pay_mold" @click="closePay">
      <div class="wechat_item">
        <div class="pay_text">
          <p>订单金额：￥{{Number(detail.order_amount).toFixed(2)}}</p>
        </div>
        <div class="code_box">
          <qrcode :value="qrcode" :options="{ size: 300 }"></qrcode>
        </div>
        <div class="pay_text" v-if="curs==1">打开微信，扫描二维码支付</div>
        <div class="pay_text" v-if="curs==4">打开支付宝，扫描二维码支付</div>
        <div class="close" @click.stop="pay_mold=false"></div>
      </div>
    </div>
    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
    <div class="back" @click="goBack">退出</div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";

export default {
  name: "HelloWorld",
  data() {
    return {
      printF: false,
      curs: 1,
      qrcode: "",
      rentTime: "",
      rentNum: 180,
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      day: "",
      timer: "",
      order_id: "",
      detail: "",
      week: "",
      total: "",
      pay_mold: false,
      warn: "",
      strReturn: "",
      ticket_no: "",
      timer2: "",
      printFs: true,
      payF: true,
      timer3: ""
    };
  },
  created() {
    this.order_id = this.$route.query.id;
    this.timer2 = setInterval(() => {
      if (this.rentNum >= 1) {
        this.rentNum = this.rentNum - 1;

        var m = Math.floor(this.rentNum / 60);
        m = m > 9 ? m : "0" + m;
        var s = this.rentNum % 60;
        s = s > 9 ? s : "0" + s;
        this.rentTime = m + ":" + s;
      } else {
        this.rentNum = 0;
        this.rentTime = "00:00";
        clearInterval(this.timer2);

        this.$api.cancelTickert(this.order_id).then(res => {
          if (res.status == 1) {
          }
        });
        clearInterval(this.timer3);
        this.$router.replace("/");
      }
    }, 1000);
  },
  mounted() {
    this.get_OrderInfo();
    this.getDay();

    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
    var that = this;
    this.$once("hook:beforeDestroy", function() {
      clearInterval(that.timer2);
      clearInterval(that.timer);
      clearInterval(that.timer3);
    });
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    closePay() {
      this.pay_mold = false;
      this.payF = true;
    },
    //取消订单
    cancelOrder() {
      this.$api.cancelTickert(this.order_id).then(res => {
        if (res.status == 1) {
          this.$router.go(-1);
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    //创建订单并且轮询支付结果
    goPay() {
      if (this.payF) {
        this.payF = false;
        var that = this;
        if (this.timer3) {
          clearInterval(this.timer3);
        }
        if (this.curs == 4) {
          //支付宝支付
          clearInterval(this.timer3);
          this.zhifubao();
        } else {
          this.$api.payTicketOrder2(this.order_id, this.curs).then(res => {
            if (res.status == 1) {
              this.qrcode = res.data.qrcode;
              this.pay_mold = true;
              this.getOrderStatus();
            } else {
              this.warn = res.msg;
              setTimeout(() => {
                this.warn = "";
                clearInterval(that.timer3);
                this.$router.replace({
                  path: "/"
                });
              }, 1500);
            }
          });
        }
      }
    },
    //支付宝支付
    zhifubao() {
      var that = this;
      this.$api.payTicketOrder2(this.order_id, this.curs).then(res => {
        if (res.status == 1) {
          this.qrcode = res.data.qr_code;
          this.pay_mold = true;
          this.getOrderStatus();
        } else {
          this.warn = res.msg;
          setTimeout(() => {
            this.warn = "";
            clearInterval(that.timer3);
            this.$router.replace({
              path: "/"
            });
          }, 1500);
        }
      });
    },
    // 获取订单信息
    get_OrderInfo() {
      this.$api.TicketInfo(this.order_id).then(res => {
        this.detail = res.data;
        this.ticket_list = res.data.item;
        this.titem_id = "";
        this.ticket_list.map((item, index) => {
          if (index == 0) {
            this.titem_id = item.tickets[0].titem_id;
          } else {
            this.titem_id += "," + item.tickets[0].titem_id;
          }
        });
        if (res.data.status == 3) {
          clearInterval(that.timer2);
          clearInterval(that.timer3);
          this.$router.replace({
            path: "/ticket_success",
            query: {
              order_id: this.order_id
            }
          });
          return false;
        }
      });
    },
    getOrderStatus() {
      let that = this;
      that.timer3 = setInterval(() => {
        this.$api.getTicketStatus(this.order_id).then(res => {
          this.order_status = res.data.order_status;
          if (res.data.order_status == 3) {
            this.pay_mold = false;
            this.warn = "支付成功";
            clearInterval(that.timer3);

            this.print_ticket();
          } else if (res.data.order_status == 2) {
          } else {
            clearInterval(that.timer3);
            this.$router.replace({
              path: "/"
            });
          }
        });
      }, 1000);
    },
    print_ticket() {
      if (this.printFs) {
        this.printFs = false;
        this.$api.print_ticket(this.titem_id).then(ress => {
          var list = ress.data;
          list.map((item, index) => {
            if (index == 0) {
              this.strReturn =
                item.ticket_name +
                "," +
                item.ticket_type +
                // "," +
                // item.toi_username +
                "," +
                item.t_date +
                "," +
                item.time_period +
                "," +
                item.toi_sn_encode +
                "," +
                item.order_sn +
                ";";
            } else {
              this.strReturn +=
                item.ticket_name +
                "," +
                item.ticket_type +
                // "," +
                // item.toi_username +
                "," +
                item.t_date +
                "," +
                item.time_period +
                "," +
                item.toi_sn_encode +
                "," +
                item.order_sn +
                ";";
            }
          });
          if (ress.status == 1) {
            this.wran = "";
            var obj = jsObj.getPageStatus();
            var pageNum = obj.split(",")[1];
            if (Number(pageNum) >= list.length) {
              this.printF = true;
              jsObj.PrintSellTicket("1", this.strReturn);

              var obj = jsObj.getPageStatus();
              var num2 = Number(obj.split(",")[1]);
              var num3 = Number(obj.split(",")[2]);
              var type = num2 < num3 ? 1 : 2;
              var timers = setTimeout(() => {
                this.$router.push({
                  path: "/ticket_success",
                  query: {
                    order_id: this.order_id,
                    type: type
                  }
                });
              }, 1500);
              clearTimeout(timers);
            } else {
              this.warn = "纸张不足，请联系客服人员";
              var timers = setTimeout(() => {
                this.warn = "";
                this.$router.replace("/nopage");
              }, 1500);
              clearTimeout(timers);
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      }
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      var weeks = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          weeks = "周日";
          break;
        case 1:
          strWeek = "星期一";
          weeks = "周一";
          break;
        case 2:
          strWeek = "星期二";
          weeks = "周二";
          break;
        case 3:
          strWeek = "星期三";
          weeks = "周三";
          break;
        case 4:
          strWeek = "星期四";
          weeks = "周四";
          break;
        case 5:
          strWeek = "星期五";
          weeks = "周五";
          break;
        case 6:
          strWeek = "星期六";
          weeks = "周六";
          break;
      }
      this.time = hours + ":" + min;
      this.day = month + "月" + days + "日 ";
      this.today = month + "月" + days + "日 " + strWeek;
      this.week = weeks;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  position: relative;
  padding-bottom: 60px;
  .top {
    padding: 68px 50px;
    color: #4d4d4d;
    font-size: 25px;
    height: 486px;
    position: relative;
    h3 {
      font-size: 70px;
      margin: 0;
    }
    .title {
      position: absolute;
      top: 100px;
      left: 55%;
      transform: translateX(-50%);
      font-size: 50px;
      font-weight: 500;
      letter-spacing: 3px;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    margin: 85px 60px 50px;
  }
  .top-center {
    padding: 60px 50px;
    margin-top: -300px;
    position: relative;
    h3 {
      color: #005192;
      font-size: 50px;
      margin-bottom: 40px;
    }
    .content {
      background: #fff;
      position: relative;
      padding: 80px 50px 0px;
      border-radius: 14px;
      border: 1px solid #005192;
      position: relative;
      margin-bottom: 80px;
      &:after {
        content: "";
        width: 100%;
        height: 1;
        border-top: 1px dashed #005192;
        position: absolute;
        left: 0;
        bottom: 210px;
      }
      .title {
        font-size: 36px;
        color: #005192;
        font-weight: 600;
        margin-bottom: 44px;
        .time {
          color: #b95020;
          font-size: 60px;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .title-seat {
        font-size: 30px;
        color: #005192;
        font-weight: 600;
        margin-bottom: 14px;
      }
      .day {
        font-size: 30px;
        color: #005192;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .name {
        font-size: 40px;
        overflow: hidden;
        color: #005192;
        font-weight: bold;
        padding-right: 120px;
        span {
          float: right;
          color: #454545;
        }
      }
      .money {
        text-align: right;
        padding: 120px 0px 72px;
        font-size: 30px;
        color: #000;
        span {
          font-size: 30px;
          color: #ff5a00;
          &.num {
            font-size: 48px;
            font-weight: 600;
          }
        }
      }
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    .icon2 {
      width: 97px;
      height: 104px;
      background: url(.././assets/print.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
// 支付方式
.payment-type {
  overflow: hidden;
  .item {
    width: 310px;
    height: 128px;
    background: url(.././assets/wx.png) no-repeat;
    background-size: cover;
    display: inline-block;
    margin-right: 20px;
    &.active {
      background: url(.././assets/wx_c.png) no-repeat;
      background-size: cover;
    }
    &:nth-child(3) {
      margin-right: 0;
      background: url(.././assets/yl.png) no-repeat;
      background-size: cover;
      &.active {
        background: url(.././assets/yl_c.png) no-repeat;
        background-size: cover;
      }
    }
    &:nth-child(2) {
      background: url(.././assets/zfb.png) no-repeat;
      background-size: cover;
      &.active {
        background: url(.././assets/zfb_c.png) no-repeat;
        background-size: cover;
      }
    }
  }
}
.mold {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;

  .wechat_item {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 480px;
    height: 600px;
    background-color: #fff;
    padding: 57px 0px;
    border-radius: 6px;
    .code_box {
      width: 300px;
      height: 300px;
      margin: 55px auto 84px;

      img {
        width: 100%;
      }
    }

    .pay_text {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      p {
        font-size: 30px;
      }
    }
    .close {
      position: absolute;
      bottom: -234px;
      left: 50%;
      transform: translateX(-50%);
      width: 109px;
      height: 231px;
      background: url(.././assets/close.png) no-repeat;
      background-size: cover;
      cursor: pointer;
    }
  }
}
.seated {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 30px 60px 30px;
  border-top: 1px dashed #005192;
  h3 {
    color: #000;
    font-size: 26px;
    margin-bottom: 15px;
  }
  p {
    color: #55555a;
    font-size: 26px;
  }
}
.seat {
  width: 158px;
  height: 60px;
  display: inline-block;
  color: #3e70b8;
  font-size: 30px;
  text-align: center;
  line-height: 60px;
  text-align: center;
  background: url(.././assets/seat.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 8px 8px 0;
}
.btn-group {
  margin: 160px auto 0;
  .back-btn {
    display: inline-block;
    width: 330px;
    height: 98px;
    border: 1px solid #b95020;
    color: #b95020;
    border-radius: 49px;
    font-size: 30px;
    line-height: 96px;
    text-align: center;
    cursor: pointer;
    margin-right: 57px;
    margin-left: 40px;
  }
  .ok {
    width: 488px;
    height: 98px;
    line-height: 98px;
    background: #b95020;
    color: #fff;
    font-size: 30px;
    border-radius: 49px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
  }
  .oks {
    width: 488px;
    height: 98px;
    line-height: 98px;
    background: #b95020;
    color: #fff;
    font-size: 30px;
    border-radius: 49px;
    text-align: center;
    cursor: pointer;
    display: block;
    margin: 0 auto;
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 35%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.footer {
  position: absolute;
  bottom: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pay.vue